(function () {
    'use strict';

    angular.module('swif.achats')

    .factory('PurchaseService', ['$q', 'swifFrameworkService', 'AchatsService',
    function ($q, swif, achats) {
        var service = {};
        service.COLLECTION_FIELDS = [
        "id", "swif_id", "name", "date_order", "description", "service_id", "user_id",
        "partner_id", "supplier_mail_sent", "date_supplier_emailed",
        "order_line", "lines", 'account_analytic_id', 'budget',
        'validation_constraint_id', 'validation_order_id', 'validation_user_item_id',
        'po_ask_id', 'all_budget_set', 'attachment_count', 'mail_message_count',
        "amount_total", "amount_untaxed", "amount_tax",
        "state", "state_order", "actions", "cancel_note",
        "attach_invoice_ids", "attach_invoices", "attach_not_invoices", "attach_waiting_invoice_ids",
        "engage_to_treat", "shipped", "shipped_rate", "warehouse_id", "picking_ids", "purchase_report_id",
        "civil_code", "linked_to_CNF", "civil_code_origin"];
        service.COLLECTION_ID = 'purchases';
        service.getCollection = function () {
            return swif.collection.getCollection(service.COLLECTION_ID);
        };

        service.createCollection = function () {
            var filter = {};
            var user = swif.user.getAuthenticatedUserData();
            if (user.service_ids) {
                swif.data.addExtraFilter(filter, 'id', 'service_id', '=',
                user.service_ids);
                swif.data.addExtraFilter(filter, 'id', '|');
                swif.data.addExtraFilter(filter, 'id', 'account_analytic_id', '=',
                false);
                swif.data.addExtraFilter(filter, 'id', 'account_analytic_id.crossovered_budget_id.service_id', 'in',
                user.service_ids);
            }
            filter.fields = service.COLLECTION_FIELDS;
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.COLLECTION_ID,
                'purchase_order',
                filter,
                {location: true}
            );
        };

        service.resolveData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createCollection());
                $q.all(defers).then(function (res) {
                    var data = {purchases: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.getPartialPicking = function (model) {
           let userContext = swif.user.getAuthenticatedUser().context;
            model.picking = {};
            return swif.data.callKw(
                'purchase_order',
                'create_partial_picking',
                [model.id],
                {context: userContext}
            ).then(function (data) {
                _.forEach(data.moves, function (move) {
                    move._initialQuantity = move.quantity;
                    move.splitted_lines = [];
                });
                _.merge(model.picking, data);
                return model;
            });
        };

        service.save = function (model) {
            function sanitizeLine (line) {
                var ret = {};
                ret.name = line.name;
                ret.product_id = achats.formatters.m2o(line.product_id);
                ret.budget_line_id = achats.formatters.m2o(line.budget_line_id);
                ret.taxes_id = [[6, 0, line._tax ? [line._tax[0]]: [] ]];
                ret.product_qty = line.product_qty || 0.0;
                ret.price_unit = line.price_unit;
                ret.warehouse_id = line.warehouse_id ? line.warehouse_id[0] : null;
                return ret;
            }
            model.order_line = swif.data.prepareOne2manyValues(
                model.order_line || [],
                model.lines,
                sanitizeLine
            );
            var ret;
            if (model.id) {
                ret = swif.data.save('purchase_order', model.id, model);
            } else {
                ret = swif.data.create('purchase_order', model);
            }
            return ret;
        };

        service.savePicking = function (model) {
            var userContext = swif.user.getAuthenticatedUser().context;
            var ret = false;
            if (model.picking) {
                var splitted_lines = [];
                for (var move of model.picking.moves) {
                    if (move.splitted_lines.length > 0) {
                        splitted_lines = splitted_lines.concat(move.splitted_lines);
                    }
                }
                model.picking.moves = model.picking.moves.concat(splitted_lines);
                model.picking.move_ids = swif.data.prepareOne2manyValues(
                    model.picking.move_ids,
                    model.picking.moves,
                    function (elt) {
                        return {
                            product_id: Array.isArray(elt.product_id) ? elt.product_id[0] : elt.product_id,
                            quantity: elt.quantity,
                            warehouse_id: elt.warehouse_id[0]
                        };
                    }
                );

                ret = swif.data.save(
                    'stock_partial_picking',
                    model.picking.id,
                    model.picking
                ).then(function () {
                    return swif.data.callKw(
                        'stock_partial_picking',
                        'do_partial',
                        [[model.picking.id]],
                        {context: userContext}
                    ).then(function () {
                        return true;
                    });
                });
            }
            return ret;
        };

        service.saveInvoices = function (model) {
            var attach_invoice_ids = swif.data.prepareOne2manyValues(
                model.attach_invoice_ids || [],
                model.attach_invoices,
                function (invoice) {
                    var ret = {
                        name: invoice.name || invoice.datas_fname,
                        datas_fname: invoice.datas_fname || name,
                        purchase_id: model.id
                    };
                    if (!invoice.id) {
                        ret.datas = invoice.datas;
                    }
                    // invoice.survey may be Undefined when user did not open the tab of an existing invoice
                    // (fortunately, it will also reduce the amount of data to the backend)
                    if (invoice.survey) {
                        var val = swif.validation.prepareObjectForSave(invoice.survey);
                        // TG-3468 - name of invoice survey inherits from purchase_order info
                        val.name = model.swif_id + ' - ' + model.description;
                        // res_id and res_model are handled by the backend
                        if (invoice.validation_order_id) {
                            ret.validation_order_id = [1, invoice.validation_order_id[0], val];
                        } else {
                            ret.validation_order_id = [0, 0, val];
                        }
                    }
                    return ret;
                }
            );
            // do not save other data than those present in modal
            var savedData = {attach_invoice_ids: attach_invoice_ids};
            return swif.data.save('purchase_order', model.id, savedData);
        };
        service.computeLines = function (purchase) {
            var baseAmount = 0.0;
            var taxAmount = 0.0;
            var amount = 0.0;
            _.forEach(purchase.lines, function (line) {
                line._tax = line.tax.id ? [line.tax.id, achats.tax.format(line.tax)] : false;

                // compute amount (using qty, price, tax, etc...) and compute _tax
                var tax = line.tax.price_include ? 0.0  : (line.tax.amount || 0);
                // var discount = (1.0 - line.discount / 100.0);
                var discount = 0.0;  // TODO: see to implement discount on Odoo
                line._baseAmount = line.price_unit * line.product_qty;
                line._taxAmount = line._baseAmount * tax;
                line._amount = line._baseAmount + line._taxAmount;

                baseAmount += line._baseAmount;
                taxAmount += line._taxAmount;
                amount += line._amount;
            });
            purchase._baseAmount = baseAmount;
            purchase._taxAmount = taxAmount;
            purchase._amount = amount;
        }

        service.computeBudgetAmount = function (line) {
            if (line.budget) {
                if (line.budget.id) {
                    line.budget.remaining_amount = line.budget.planned_amount - line.budget.openstc_practical_amount;
                }
            }
        };

        service.computeBudgets = function (purchase) {
            _.forEach(purchase.lines, function (line) {
                if (!line.budget_line_id) {
                    line.budget = purchase.budget || {};
                    line.budget_line_id = purchase.account_analytic_id;
                }
                service.computeBudgetAmount(line);
            });
            service.computeBudgetAmount(purchase);
        }

        service.addLine = function (purchase, product) {
            function addLineDataAndCompte(item) {
                swif.data.get('consumable', undefined, filter).then(function(cons) {
                    getProductConsumables(cons, item)
                })
                purchase.lines.push(item);
                service.computeLines(purchase);
                service.computeBudgets(purchase);
            }
            var found = _.find(purchase.lines, function (elt) {
                var prodId = elt.product_id ? elt.product_id[0]: false;
                return prodId === product.product_id[0];
            });
            if (found) {
                found.product_qty += 1;
                service.computeLines(purchase);
                service.computeBudgets(purchase);
            } else  if (product.id) {
                var item = service.prepareLineFromProduct(product, purchase);
                if (!purchase.lines) {
                    purchase.lines = [];
                    addLineDataAndCompte(item);
                }
                var filter = {};
                filter.fields = ['default_warehouse_id', 'price'];
                swif.data.addFilter(filter, 'id', '=', product.id);
                swif.data.searchRead('consumable', filter).then(function (consumables) {
                    if (!_.isEmpty(consumables.records)) {
                        let user = swif.user.getAuthenticatedUserData();
                        // Retrieve default warehouse for this product
                        if (user.warehouse_ids.indexOf(consumables.records[0].default_warehouse_id[0]) !== -1) {
                            item.warehouse_id = consumables.records[0].default_warehouse_id;
                        }
                        item.price_unit = consumables.records[0].price;
                    }
                    if (purchase._warehouse_id) {
                        item.warehouse_id = purchase._warehouse_id;
                    }
                    addLineDataAndCompte(item);
                });
            }
        }

        service.prepareLineFromProduct = function (product, model) {
            let defaultTax = achats.tax.getDefault(achats.tax.lastData);
            return {
                name: product.name,
                product_qty: 1,
                price_unit: product.price_unit || 0.0,
                _tax: false,
                tax: defaultTax || {}
            };
        };

        const getProductConsumables = (consumables, item) => {
            let newFilter = {fields: ['id', 'name']}
            swif.data.addFilter(newFilter, 'id', '=', consumables[0].product_id)
            swif.data.get('product', undefined, newFilter).then(function(product) {
                item.product_id = [product[0].id, product[0].name];
            })
        }


        function getWarehouseAndProductData(product, item, model) {
            let user = swif.user.getAuthenticatedUserData();
            let filter = {};
            filter.fields = ['default_warehouse_id', 'price'];
            swif.data.addFilter(filter, 'id', '=', product.id);
            swif.data.get('consumable', undefined, filter).then(function (consumables) {
                if (user.warehouse_ids.indexOf(consumables[0].default_warehouse_id[0]) !== -1){
                    item.warehouse_id = consumables[0].default_warehouse_id;
                }
                getProductConsumables(consumables, item);
            })
            model.lines.push(item);
            return model;
        }

        service.initializeFromConsumables = function (model) {
            return achats.tax.fetchChoices().then(function (data) {
                // finally, add a purchase line for each product
                let products = swif.cart.getCartItems('consumable_stock')
                _.forEach(products, function (product) {
                    let item = service.prepareLineFromProduct(product, model);
                    getWarehouseAndProductData(product, item, model);
                });
            });
        };

         service.preModal = function (data) {
            var ret = service.getCollection().preModal(data);
            if(data.action.id === 'add') {
                delete data.model.id;
                data.model._type = 'purchase_order';
                data.model.lines = [];
                // initializeFromConsumables is now called on controller directly
                // (for async purpose: computeLines() called befure this method finish his process)
                // service.initializeFromConsumables(data.model);
            } else if (_.contains(['receive'], data.action.id)) {
                service.getPartialPicking(data.model);
            }
            return ret;
        };

        service.preValidate = function (data) {
            function wkf (signal) {
                return swif.data.execWorkflow(
                    'purchase_order',
                    data.model.id,
                    signal
                ).then(onSuccess);
            }
            function onSuccess () {
                return true;
            }

            var ret;
            var userContext = swif.user.getAuthenticatedUser().context;
            switch (data.action.id)  {
                case 'add':
                    ret = service.save(data.model);
                    break;
                case 'edit':
                    ret = service.save(data.model);
                    break;
                case 'confirm':
                    ret = wkf('purchase_confirm');
                    break;
                case 'to_confirm':
                    var val = swif.validation.prepareObjectForSave(data.model.survey);
                    val.name = data.model.name;
                    val.res_id = data.model.id;
                    val.res_model = 'purchase.order';
                    ret = swif.data.create('validation-order', val);
                    break;
                case 'need_confirm':
                    var val = swif.validation.prepareObjectForSave(data.model.survey);
                    val.name = data.model.name;
                    val.res_id = data.model.id;
                    val.res_model = 'purchase.order';
                    ret = swif.data.create('validation-order', val);
                    break;
                case 'validation_confirm':
                    if (data.model.validation_user_item_id) {
                        ret = swif.data.callKw(
                            'validation-block-item',
                            'confirm',
                            [data.model.validation_user_item_id],
                            {message: data.model.note || '', context: userContext}
                        ).then(onSuccess);
                    }
                    break;
                case 'validation_refuse':
                    if (data.model.validation_user_item_id) {
                        ret = swif.data.callKw(
                            'validation-block-item',
                            'refuse',
                            [data.model.validation_user_item_id],
                            {message: data.model.note || '', context: userContext}
                        ).then(onSuccess);
                    }
                    break;
                case 'manage_invoice':
                    ret = service.saveInvoices(data.model);
                    break;
                case 'receive':
                    ret = service.savePicking(data.model);
                    break;
                case 'cancel':
                    ret = wkf('purchase_cancel');
                    break;
                case 'done':
                    ret = wkf('done');
                    break;
                case 'purchase_to_confirm_ciril_GF':
                    ret = wkf('purchase_to_confirm_ciril_GF');
                    break;
                case 'validation_confirm_ciril_GF':
                    ret = wkf('validation_confirm_ciril_GF');
                    break;
                default:
                    ret = service.getCollection().preValidate(data);
            }
            return ret;
        };

        service.callback = function (error, data) {
            if (data.action.id === 'add') {
                // TODO: could not use fasterCallback (for now),
                // data.result is not defiend here (perharps because modal.http is not defined)
                service.getCollection().getItems();
                achats.product.emptyConsumablesCart();
                swif.collection.defaultCallbackMessage(error, data);
            }
            else if (_.contains(swif.collection.defaultActionIds, data.action.id)) {
                service.getCollection().fasterCallback(data);
            }
            else {
                service.getCollection().updateItem(data.model);
            }
        };

        service.getFilters = function (purchase) {
            var ret = {
                budget_line_id: {fields: ['name', 'complete_name', 'openstc_practical_amount', 'planned_amount', 'openstc_erosion']},
                product_id: {},
                supplier: {},
                warehouse: {},
                department: {},
            };
            var user = swif.user.getAuthenticatedUserData();
            achats.filters.getProductFilter(ret.product_id, user.service_ids);
            achats.filters.getWarehouseFilter(ret.warehouse);
            swif.data.addFilter(ret.supplier, 'type_id.product_supplier', '=', true);
            var user = swif.user.getAuthenticatedUserData();
            swif.data.addFilter(ret.department, 'id', 'in', user.service_ids);
            return ret;
        };

        service.getCountFilter = function () {
            var ret = {info: {}, success: {}};
            swif.data.addFilter(ret.info, 'state', 'in', ['wait']);
            swif.data.addFilter(ret.success, 'state', 'in', ['approved']);
            return ret;
        };
        return service;
    }])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/achats-stocks/purchases/table_view', {
            templateUrl: 'partials/achats/purchases_table_view.html',
            controller: 'PurchasesController',
            resolve: {
                data: ['PurchaseService', function (service) {
                    return service.resolveData();
                }]
            },
            reloadOnSearch: false
        });
    }])

    .controller('PurchasesController', [
        '$scope', 'swifFrameworkService', 'PurchaseService', 'data', 'AchatsService',
        function ($scope, swif, service, data, achats) {

            function _doAction(purchase, action, $event) {
                if (action) {
                    var options = {
                        preModal: $scope.preModal,
                        preValidate: $scope.preValidate,
                        callback: $scope.callback
                    };
                    swif.action.dispatch('purchase_order', action, purchase, options);
                }
                // avoid tr to be de-selected (collection directive)
                if ($event) {
                    $event.stopPropagation();
                }
            }

            function doActionRead (purchase, $event) {
                var action = swif.action.getActionById('purchase_order', 'misc', 'read', purchase);
                _doAction(purchase, action, $event);
            }

            function doActionShowValidation (purchase, $event) {
                var action = swif.action.getActionById('purchase_order', 'misc', 'show_validation', purchase);
                _doAction(purchase, action, $event);
            }

            function doActionShowInvoice (purchase, $event) {
                var action = swif.action.getActionById('purchase_order', 'misc', 'show_invoice', purchase);
                _doAction(purchase, action, $event);
            }

            function doActionManageInvoice (purchase, $event) {
                var action = swif.action.getActionById('purchase_order', 'workflow', 'manage_invoice', purchase);
                _doAction(purchase, action, $event);
            }

            function initialize () {
                $scope.purchases = data.purchases;
                $scope.preModal = service.preModal;
                $scope.preValidate = service.preValidate;
                $scope.callback = service.callback;
                $scope.countFilter = service.getCountFilter();
                var action = achats.product.parseLocationForAction();
                if (action.actionId) {
                    var action = swif.action.getActionById(
                        'purchase_order',
                        action.category,
                        action.actionId,
                        {}
                    );
                    _doAction({}, action);
                }
            }
            initialize();


            if (swif.module.modules.opengst_civil){
                swif.settings.app.contentTypes.purchase_order.filterSettings.push(
                    {
                        "field": "linked_to_CNF",
                        "name": "Commande CirilGF",
                        "type": "bool"
                    }
                )
                // get cron to print informations about last ciril GF fetch and next one
                var translatedTimeTypes = {
                    'minutes': 'minute(s)',
                    'hours': 'heure(s)',
                    'days': 'jour(s)',
                    'work_days': 'jour(s) ouvré(s)',
                    'weeks': 'semaine(s)',
                    'months': 'mois'
                };
                var cronFilter = {};
                swif.data.addFilter(cronFilter, 'function', '=', 'import_ciril_gf_purchases');
                swif.data.get('cron', undefined, cronFilter).then( cron => {
                    $scope.cron = cron[0];
                    if (cron[0] && cron[0].nextcall && moment().utcOffset()){
                        $scope.cron.absoluteNextcall = moment.utc(cron[0].nextcall).add(moment().utcOffset(), 'minutes').format('DD/MM/YYYY HH:mm');
                        $scope.cron.timeType = translatedTimeTypes[$scope.cron.interval_type];
                    }
                });
            }


            $scope.onClickPurchase = function (purchase, $event) {
                doActionRead(purchase, $event);
            };
            $scope.onClickShowValidation = function (purchase, $event) {
                doActionShowValidation(purchase, $event);
            };
            $scope.onClickShowInvoices = function (purchase, $event) {
                doActionShowInvoice(purchase, $event);
            };
            $scope.onClickManageInvoices = function (purchase, $event) {
                doActionManageInvoice(purchase, $event);
            };
        }
    ])

    .controller('PurchaseController', [
        '$scope', '$q', '$sce', 'swifFrameworkService', 'PurchaseService', 'AchatsService', 'swifOpenbaseCompanyService', 'gettextCatalog',
        function ($scope, $q, $sce, swif, service, achatsSrv, companySrv, gettextCatalog) {
            $scope.modules = swif.module.modules;

            var user = swif.user.getAuthenticatedUserData();
            for(const line of $scope.model.lines) {
                if (user.warehouse_ids.indexOf(line.warehouse_id[0]) === -1) {
                    delete line.warehouse_id;
                }
            }

            $scope.translate = {
                'hideBudget': gettextCatalog.getString('Hide budget'),
                'showBudget': gettextCatalog.getString('Show budget'),
                'allocateBudget': gettextCatalog.getString('Allocate a budget')
            };

            function removeLine (purchase, line) {
                _.remove(purchase.lines, line);
                // Permit to  refresh  the amount if you remove one line
                service.computeLines(purchase);
                service.computeBudgets(purchase);
            }

            $scope.onClickSetDefaultBudget = function (purchase, line) {
                if ($scope.model.account_analytic_id) {
                    // TOCHECK; (reference issue) does the change of default budget
                    // changes line being bind to default budget ?
                    line.budget_line_id = $scope.model.account_analytic_id;
                    line.budget = purchase.budget;
                    service.computeBudgets(purchase);
                }
            };

            $scope.onChangeLine = function (purchase, line) {
                service.computeLines(purchase);
            };

            $scope.onChangeBudget = function (purchase, budget) {
                purchase.budget = budget;
                service.computeBudgets(purchase);
            };
            $scope.onChangeBudgetLine = function (purchase, line, budget) {
                line.budget = budget;
                service.computeBudgets(purchase);
            };

            $scope.onChangeTax = function (purchase, line, tax) {
                line.tax = tax;
                $scope.onChangeLine(purchase, line);
            };

            $scope.onChangeFakeProduct = function (purchase, product) {
                service.addLine(purchase, product);
                $scope.fakes.product_id = false;
            };

            $scope.onClickRemoveLine = function (purchase, line) {
                removeLine(purchase, line);
            };

            $scope.duplicateLine = function (line) {
                $scope.model.lines.push(angular.copy(line));
            };

            $scope.formatName = achatsSrv.formatName;

            $scope.formatNameBudget = function (product) {
                var label = "<i class='fa fa-money' aria-hidden='true'></i> ";
                label += product.complete_name;

                return $sce.trustAsHtml(label);
            };

            $scope.onChangeCivilSwitch = function (linked_to_CNF) {
                // update filter in case of CNF or not
                $scope.filters = service.getFilters();
                $scope.filters.product_id.fields = ['id', 'product_id', 'name', 'complete_name', 'is_stock'];

                if (linked_to_CNF === true) {
                    swif.data.addFilter($scope.filters.supplier, 'civil_code', '!=', false);
                    swif.data.addFilter($scope.filters.budget_line_id, 'crossovered_budget_id.exercice_civil', '!=', false);
                    if ($scope.formerPartnerId && !$scope.readonly) {
                        $scope.partnerHelpText = 'Fournisseur renseigné initialement : ' + $scope.formerPartnerId[1];
                    }
                } else {
                    $scope.partnerHelpText = '';
                }
                $scope.model.partner_id = $scope.formerPartnerId;
            };

            $scope.$watch('model._warehouse_id', function (newV, oldV) {
                if (newV && !angular.equals(newV,oldV)) {
                    for (const line of $scope.model.lines)
                        line.warehouse_id = newV;
                }
            });

            function initialize () {
                // follow configuration settings on "sending to CirilGF" choice.
                if ($scope.modules.opengst_civil) {
                    companySrv.getGlobalSettingsPurchases().then(function(company) {
                        $scope.companySettings = company;
                        if (!$scope.model.id) {
                            if ($scope.companySettings.force_all_purchase_order_to_be_sent_to_civil){
                                $scope.model.linked_to_CNF = true;
                            } else {
                                $scope.model.linked_to_CNF = $scope.companySettings.default_value_sent_to_civil;
                            }
                        }
                        $scope.formerPartnerId = $scope.model.partner_id;
                        $scope.onChangeCivilSwitch($scope.model.linked_to_CNF)
                    });
                }
                $scope.fakes = {product_id: false};
                $scope.readonly = $scope.action.id === 'read';
                $scope.filters = service.getFilters();
                $scope.filters.product_id.fields = ['id', 'product_id', 'name', 'complete_name', 'is_stock'];
                swif.data.addFilter($scope.filters.budget_line_id, 'crossovered_budget_id.state', '!=', 'done');
                $scope.choices = {taxes: []};
                var promise;
                if ($scope.model.id) {
                    promise = achatsSrv.tax.fetchChoices();
                } else {
                    // initialize new model with consumables cart
                    promise = service.initializeFromConsumables($scope.model);
                }

                promise.then(function () {
                    // lastData has a value thanks to initializeFromConsumables,
                    // which has called tax.fetchChoices() itself.....
                    $scope.choices.taxes = achatsSrv.tax.lastData;
                    service.computeLines($scope.model);
                    service.computeBudgets($scope.model);
                });
            }
            initialize();
        }
    ])

    .controller('PurchaseActionsModalController', [
        '$scope', 'swifFrameworkService', 'PurchaseService', 'AchatsService',
        function ($scope, swif, service, achats) {

            function initialize () {
                var show = $scope.action.id === 'show_validation';
                var isSurvey = $scope.action.id === 'to_confirm';
                var isValidation = $scope.action.id === 'need_confirm';
                var isValidationChoice = _.contains(['validation_confirm', 'validation_refuse'], $scope.action.id);
                $scope.isTransferCirilGF = _.contains(['purchase_to_confirm_ciril_GF', 'validation_confirm_ciril_GF'], $scope.action.id);
                $scope.usr = swif.user.getAuthenticatedUserData();
                var creator = [$scope.usr.id, $scope.usr.name];
                if (show && $scope.model.validation_order_id) {
                    $scope.initialize = false;
                    $scope.readonly = true;
                    $scope.forced = false;
                    $scope.model.survey = swif.validation.getObjectFromServer(
                        $scope.model.validation_order_id[0]
                    );
                }
                else if (isSurvey) {
                    $scope.initialize = true;
                    $scope.readonly = false;
                    $scope.forced = false;
                    $scope.userFilter = {};
                    swif.data.addFilter($scope.userFilter, 'groups_id.code', '=', 'purchase_order_confirm');
                    $scope.model.survey = swif.validation.initValidationModel();
                }
                else if (isValidation) {
                    $scope.initialize = false;
                    $scope.readonly = false;
                    $scope.forced = true;
                    $scope.model.survey = {};
                    if ($scope.model.validation_constraint_id) {
                        var val = swif.validation.getTemplateFromServer(
                            $scope.model.validation_constraint_id[0],
                            true
                        );
                        $scope.model.survey = val;
                        $scope.model.survey.creator_id = creator;
                    }
                } else if (isValidationChoice) {
                    $scope.currentUser = $scope.usr;
                // disable form submit button if user does not have hability to send to CirilGF
                } else if ($scope.isTransferCirilGF) {
                    if (!$scope.usr.civil_claimer_code) {
                        $scope.form.$waitAction = true;
                    }
                    // to automatically update claimer_code
                    swif.data.get('user', $scope.usr.id).then( updatedUser => {
                        $scope.currentUser = updatedUser;
                        if ($scope.currentUser.civil_claimer_code) {
                            $scope.form.$waitAction = false;
                        }
                    });
                }

            }
            initialize();
        }
    ])

    .controller('PurchaseManageInvoiceController', [
        '$scope', 'swifFrameworkService', 'PurchaseService', 'AchatsService',
        function ($scope, swif, service, achats) {
            var usr = swif.user.getAuthenticatedUserData();
            function fillWithTemplate (model, templateId) {
                var val = swif.validation.getTemplateFromServer(templateId, true);
                val.template_id = model.survey.template_id || false;
                model.survey = val;
                model.survey.creator_id = [usr.id, usr.name];
            }

            function fillFromServer (model, validationId) {
                model.survey = swif.validation.getObjectFromServer(validationId);
            }

            function setSelectedInvoice (invoice) {
                if (invoice !== $scope.selectedInvoice) {
                    // update the permissions values
                    $scope.can = {
                        updateWkf: !invoice.validation_order_id,
                        decide: !$scope.can.readonly && invoice.validation_order_id
                    };
                    // lazy initialize the validation object ('survey')
                    if (!invoice.survey) {
                        invoice.survey = swif.validation.initValidationModel();
                        // try to retrieve the template from the last invoice
                        var selected = $scope.selectedInvoice || false;
                        // for new invoice, try to pre-fill the validation template
                        if (!invoice.validation_order_id && !invoice.survey.template_id && selected) {
                            var defaultTemplate = selected.survey.template_id || false;
                            if (defaultTemplate) {
                                invoice.survey.template_id = defaultTemplate;
                                fillWithTemplate(invoice, invoice.survey.template_id[0]);
                            }
                        }
                        // for existing invoice, fetch their validation from server
                        else if (invoice.validation_order_id) {
                            fillFromServer(invoice, invoice.validation_order_id[0]);
                        }
                    }
                    // finally, set the selected invoice
                    $scope.selectedInvoice = invoice;
                }
            }

            function initialize () {
                $scope.filters = {
                    user: {},
                    fromTemplate: {}
                };
                $scope.can = {
                    updateWkf: false,
                    decide: false,
                    readonly: $scope.action.id === 'show_invoice'
                };
                swif.data.addFilter($scope.userFilter, 'groups_id.code', '=', 'manage_invoice');
                swif.data.addFilter($scope.filters.fromTemplate, 'is_purchase_invoice', '=', true);
                if ($scope.model.attach_invoices.length > 0) {
                    setSelectedInvoice($scope.model.attach_invoices[0]);
                }
            }

            initialize();
            $scope.onClickInvoice = function (invoice) {
                setSelectedInvoice(invoice);
            };
            $scope.onChangeTemplate = function (template) {
                if (template.id) {
                    fillWithTemplate($scope.selectedInvoice, template.id);
                }
            };

            $scope.onClickAddInvoice = function () {
                var newModel = {state: 'not_paid'};
                $scope.model.attach_invoices.push(newModel);
                setSelectedInvoice(newModel);
            };
            $scope.onChangeFile = function (value, filename) {
                if (!$scope.selectedInvoice.name || $scope.selectedInvoice.name === $scope.selectedInvoice.datas_fname) {
                    $scope.selectedInvoice.name = filename;
                }
                $scope.selectedInvoice.datas_fname = filename;
            };
        }
    ])

    .controller('PurchaseReceiveModalController', ['$scope', 'swifFrameworkService',
        function ($scope, swif) {
            $scope.onRemoveLine = function (move) {
                _.remove($scope.model.picking.moves, move);
            };

            $scope.moveQuantity = function (move) {
                if (move.splitted_lines.length === 0) {
                    return move.quantity;
                }
                var quantity = _.sum(move.splitted_lines, function(line) {
                    return line.quantity;
                });
                return quantity + move.quantity
            };

            $scope.splitPurchase = function(move) {
                if (!Array.isArray(move.splitted_lines)) {
                    move.splitted_lines = []
                }
                var userContext = swif.user.getAuthenticatedUser().context;
                swif.data.callKw(
                    'stock_partial_picking_line',
                    'duplicate_line',
                    [move.id],
                    {context: userContext}
                ).then(function (data) {
                    data.quantity = 1;
                    move.splitted_lines.push(data);
                });
            }

            $scope.$watch('model._warehouse_id', function (newV, oldV) {
                if (newV && !angular.equals(newV,oldV)) {
                    for (const move of $scope.model.picking.moves)
                        move.warehouse_id = newV;
                }
                $scope.model._warehouse_id = undefined;
            });
        }
    ]);
})();
